module.exports = __webpack_public_path__ + "static/media/arcgis_online-advanced_viewer.1423c7c1.png";